import type { OperationVariables, QueryResult, QueryFunctionOptions } from '@apollo/client';
import type { DocumentNode } from 'graphql';
import { useQuery as useApolloQuery } from '@apollo/client';

export interface QueryHookOptions<
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
> extends QueryFunctionOptions<TData, TVariables> {
  query?: DocumentNode;
}

export function useQuery<TData = any, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> {
  const {
    client,
    error,
    data,
    loading,
    networkStatus,
    called,
    startPolling,
    stopPolling,
    subscribeToMore,
    updateQuery,
    refetch,
    fetchMore,
    variables,
    observable,
    reobserve,
  } = useApolloQuery(query, options);

  // forcing throwing error, so that sentry ErrorBoundary can pick it up
  if (error) throw error;

  return {
    data,
    loading,
    networkStatus,
    client,
    called,
    startPolling,
    stopPolling,
    subscribeToMore,
    updateQuery,
    refetch,
    fetchMore,
    variables,
    observable,
    reobserve,
  };
}
